import React from "react";
import { useTheme } from "./AHTheme/AHTheme";
import { View } from "react-native";
import Color from "color";
import { useScaleFactor } from "./AHScaleFactor";

export function AHPageIndicator({
  numberOfItems,
  currentIndex,
  direction,
}: {
  numberOfItems: number;
  currentIndex: number;
  direction?: "horizontal" | "vertical";
}) {
  const items = Array(numberOfItems).fill("");
  const theme = useTheme();
  const sf = useScaleFactor();
  return (
    <View
      style={[
        {
          flexDirection: direction === "vertical" ? "column" : "row",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          backgroundColor: Color(theme.lightText).alpha(0.8).toString(),
          borderRadius: sf * 9,
          padding: sf * 6,
          alignSelf: "center",
        },
      ]}
    >
      {items.map((_, index) => {
        return (
          <View
            key={index}
            style={{
              borderRadius: sf * 3,
              overflow: "hidden",
              width: sf * 6,
              flexGrow: 0,
              height: sf * 6,
              marginLeft:
                sf * (direction !== "vertical" && index !== 0 ? 8 : 0),
              marginTop: sf * (direction === "vertical" && index !== 0 ? 4 : 0),

              backgroundColor:
                currentIndex === index
                  ? theme.darkText
                  : Color(theme.darkText).alpha(0.2).toString(),
            }}
          />
        );
      })}
    </View>
  );
}
